import { combineReducers } from "redux";

import Posts from './posts';


export default combineReducers({
  Posts
})